import { type SubtotalsData } from 'common/visualizations/views/agGridReact/types';
import { type SubTotalRow } from '../type';
import { populateSubtotalValues } from './subtotalUtils';

export const createSubtotalRow = (
  groupKeys: string[],
  groupColumnIds: string[],
  pivotFields: string[],
  groupLevel: number,
  subtotalLookup: SubtotalsData | undefined,
): SubTotalRow => {
  const subtotalRow: SubTotalRow = {
    _rowType: 'subTotal',
    _groupLevel: groupLevel,
    _groupKeys: groupKeys,
  };

  const groupKeyAtLevel = groupKeys[groupLevel];
  if (groupKeyAtLevel !== undefined) {
    const columnId = groupColumnIds[groupLevel];
    subtotalRow[columnId] = groupKeyAtLevel === 'null' ? null : groupKeyAtLevel;
  }

  populateSubtotalValues(subtotalRow, pivotFields, groupKeys, groupLevel, subtotalLookup);

  return subtotalRow;
};
